import React from 'react';
import { InfoCardVariants, TableColumn } from '@backstage/core-components';
import { EntityTable, useEntity } from '@backstage/plugin-catalog-react';
import { Entity, RELATION_HAS_PART } from '@backstage/catalog-model';
import { RelatedEntitiesCard } from '../RelatedEntitiesCard/RelatedEntitiesCard';

export interface HasServiceCardProps {
  variant?: InfoCardVariants;
}

export const HasServicesCard = (props: HasServiceCardProps) => {
  const { variant = 'gridItem' } = props;
  const { entity } = useEntity();

  const resourceEntityColumns: TableColumn<Entity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'system' }),
    EntityTable.columns.createSpecLifecycleColumn(),
  ];

  const asResourceEntities = (entities: Entity[]): Entity[] =>
    entities as Entity[];
  const title = entity.kind === 'Services' ? 'Sub-Services' : 'Services';

  return (
    <RelatedEntitiesCard
      variant={variant}
      title={title}
      entityKind="Service"
      relationType={RELATION_HAS_PART}
      columns={resourceEntityColumns}
      asRenderableEntities={asResourceEntities}
    />
  );
};
